import React from "react";

const SearchContext = React.createContext({searchTerm:null, setSearchTerm:()=>{}});
export default SearchContext;

